import { render, staticRenderFns } from "./CompanyRedeemsWrapper.vue?vue&type=template&id=9bab5c12"
import script from "./CompanyRedeemsWrapper.vue?vue&type=script&lang=js"
export * from "./CompanyRedeemsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports